var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "j-select-biz-component",
    _vm._g(
      _vm._b(
        { attrs: { width: 1000, selectButtonText: _vm.selectButtonText } },
        "j-select-biz-component",
        _vm.configs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }